import {
  Button,
  Col,
  Input,
  Row,
  Select,
  SelectOption,
  Text,
  message,
} from 'components';
import React, { useContext } from 'react';
import styled from 'styled-components';
import { OBJECT_ID_REGEX } from 'utils/constants';
import {
  findLatestRetsListingByMlsNumber,
  findById as findRetsListingById,
} from '../../../../../api/RetsListingController';
import TriggerRetsUpdatePageContext from './TriggerRetsListingUpdatePageContext';

const buildBoardElement = (
  board: string,
  boardId: string,
  fullName: string,
) => (
    <SelectOption key={boardId} value={boardId} label={board}>
      <Text>{board}</Text>&nbsp;<Text type="secondary">{fullName}</Text>
    </SelectOption>
  );

const ListingFinder: React.FC = () => {
  const {
    boards,
    retsListingMlsNumber,
    setRetsListingMlsNumber,
    retsListingBoardId,
    setRetsListingBoardId,
    retsListingId,
    setRetsListingId,
    setRetsListing,
    setUpdates,
  } = useContext(TriggerRetsUpdatePageContext);

  const getListing = async () => {
    const validId = Boolean(retsListingId.match(OBJECT_ID_REGEX));
    const validNumber =
      Boolean(retsListingMlsNumber) &&
      Boolean(retsListingBoardId) ===
        Boolean(retsListingBoardId.match(OBJECT_ID_REGEX));
    if (!validId && !validNumber)
      return message.error('Not enough info entered to find a listing');

    try {
      const res = validId
        ? await findRetsListingById(retsListingId)
        : await findLatestRetsListingByMlsNumber({
            mlsNumber: retsListingMlsNumber,
            boardId: retsListingBoardId,
          });
      setRetsListing(res);
      // @ts-ignore
      setRetsListingId(res._id.toString());
      setRetsListingMlsNumber(res.mlsNumber);
      setRetsListingBoardId(res.boardId.toString());
      setUpdates({});
    } catch (e) {
      message.error(e?.response?.data?.message || 'Could not find Listing');
    }
  };

  return (
    <StyledForm>
      <Text>Select Listing (Choose one of the two selection methods)</Text>
      <Row gutter={16}>
        <Col span={12}>
          <Input
            label="Listing MLS Number"
            required
            value={retsListingMlsNumber}
            onChange={e => {
              setRetsListingMlsNumber(e.target.value);
              setRetsListingId('');
            }}
          />
        </Col>
        <Col span={12}>
          <Select
            showSearch
            label="Listing Board"
            allowClear
            filterOption={(input, option) =>
              (option!.label as string)
                .toUpperCase()
                .includes(input.toUpperCase())
            }
            value={retsListingBoardId}
            onChange={boardId => {
              setRetsListingBoardId(boardId || '');
              setRetsListingId('');
            }}
          >
            {boards!.map(board =>
              buildBoardElement(board.board, board._id, board.name),
            )}
          </Select>
        </Col>
      </Row>
      <Input
        label="retsListing ObjectId"
        maxLength={24}
        showCount
        required
        value={retsListingId}
        onChange={e => setRetsListingId(e.currentTarget.value)}
      />
      <Button onClick={getListing}>Find Listing</Button>
    </StyledForm>
  );
};

export default ListingFinder;

const StyledForm = styled.form`
  width: 750px;
  display: grid;
  grid-gap: 15px;
`;
